export default {
    en: {
        number: 3,
        diagramId: 2,
        answers: 'fish contain trimethylamine N-oxide (TMAO), TMAO stops working',
        interactiveBoxNumber: [1],
        blocks:
            [
                {
                    task: {
                        question: 'Deepwater fish contain trimethylamine N-oxide (TMAO), which maintains the osmotic pressure needed to keep water from diffusing into their cells',
                        answer: '<span class="correct-answer-box">Deepwater <span class="highlight__answer highlight__answer_correct">fish contain trimethylamine N-oxide (TMAO),</span> which maintains the osmotic pressure needed to keep water from diffusing into their cells</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'However, TMAO stops working below 7,000 meters, presumably dooming any fish swimming deeper to “drown”',
                        answer: '<span class="correct-answer-box">However, <span class="highlight__answer highlight__answer_correct">TMAO stops working</span> below 7,000 meters, presumably dooming any fish swimming deeper to “drown”</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Thus the chances of photographing fish in the Hadad trenches (between 8,000 and 10,000 meters) are remote',
                        answer: '<span class="correct-answer-box">Thus the chances of photographing fish in the Hadad trenches (between 8,000 and 10,000 meters) are remote</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise3.js